// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"154":"c5ce05babe9f91c7","953":"512e9ebb8d6e9c46"}[chunkId] + ".js";
};